import {
  Grid,
  ICON_TROPHY_OUTLINE, Message, Spacing, Stack, Text,
} from '@doveit/bricks';
import { formatEuro } from '@doveit/hammer';
import React from 'react';
import { GOAL_METRICS, ManagerGoal } from '../../../providers/api/dtos';
import { currentYear } from '../../../utils/time/time';
import ManagerGoalPerformanceSummaryCard from '../../components/manager-goal-performance-summary-card/ManagerGoalPerformanceSummaryCard';
import getShortAgentName from '../../../utils/agent/getShortAgentName';
import TutorialView from '../../../components/tutorial-view/TutorialView';
import { MANAGER_GOAL_VIDEO_TUTORIAL } from '../../../constants';

export interface ManagerGoalMetricsViewProps extends React.AriaAttributes {
  goal: ManagerGoal,
}

export const ManagerGoalMetricsView: React.FC<ManagerGoalMetricsViewProps> = ({
  goal,
  ...rest
}) => {
  const teamMembersWithMissingTargets = (goal.target.issues || [])
    ?.filter(({ type }) => type === 'MISSING_TARGET')
    .map((issue) => getShortAgentName(issue.agent.name));

  return (
    <Spacing margin={[150, 0, 0]}>
      <Stack gap={300} {...rest}>
        <Grid gutter={75}>
          <Grid.Unit size={{ MD: 1 / 2 }}>
            <Stack gap={150}>
              <Message
                message={`Il tuo obiettivo di fatturato annuale per il ${currentYear()} è di ${formatEuro(goal.target.manager)}`}
                icon={ICON_TROPHY_OUTLINE}
              />

              <Text.BodySmall>
                Per raggiungere il il tuo obiettivo di fatturato annuale, è necessario che il tuo team effettui un numero minimo di notizie, appuntamenti, mandati e vendite annuali. <br />
                I dati riportati sono aggiornati giornalmente.
              </Text.BodySmall>
            </Stack>
          </Grid.Unit>

          <Grid.Unit size={{ MD: 1 / 2 }}>
            <TutorialView {...MANAGER_GOAL_VIDEO_TUTORIAL} />
          </Grid.Unit>
        </Grid>

        <Message
          type={teamMembersWithMissingTargets.length > 0 ? 'critical' : 'info'}
          message={`I membri del tuo team hanno definito un obiettivo cumulativo di ${formatEuro(goal.target.team)}`}
        >
          {teamMembersWithMissingTargets.length > 0
            ? `Manca l'obiettivo di: ${teamMembersWithMissingTargets.join(', ')}.`
            : undefined}
        </Message>

        <Grid gutter={75}>
          {GOAL_METRICS.map((metric) => (
            <Grid.Unit size={{ MD: 1 / 2 }} key={metric}>
              <ManagerGoalPerformanceSummaryCard
                metric={metric}
                goal={goal}
              />
            </Grid.Unit>
          ))}
        </Grid>
      </Stack>
    </Spacing>
  );
};
